export const APP_URL_PREFIX = '/afya-imara/get-quote';

export const PAGE_INDICES = {
    LANDING_PAGE: -1,
    QUOTE: 0,
    LIVES_COVERED: 1,
    MEDICAL_HISTORY: 2,
    PAYMENT: 3,
};

export const PAGES = [
    {
        URL: `${APP_URL_PREFIX}/family`,
        URL_PART: 'get-quote',
        TITLE: 'Get Quote',
    },
    {
        URL: `${APP_URL_PREFIX}/lives-covered`,
        URL_PART: 'lives-covered',
        TITLE: 'Lives Covered',
    },
    {
        URL: `${APP_URL_PREFIX}/medical-history`,
        URL_PART: 'medical-history',
        TITLE: 'Medical History',
    },
    // {
    //     URL: `${APP_URL_PREFIX}/upload-documents`,
    //     URL_PART: 'upload-documents',
    //     TITLE: 'Upload Documents',
    // },
    {
        URL: `${APP_URL_PREFIX}/payments`,
        URL_PART: 'payment',
        TITLE: 'Payment',
    },
];

export const TOGGLE_STATUS = {
    YES: true,
    NO: false,
    UNTOUCHED: 'untouched',
};

export const AFYA_IMARA_URLS = {
    QUOTE: PAGES[PAGE_INDICES.QUOTE].URL,
    LIVES_COVERED: PAGES[PAGE_INDICES.LIVES_COVERED].URL,
    MEDICAL_HISTORY: PAGES[PAGE_INDICES.MEDICAL_HISTORY].URL,
    PAYMENT: PAGES[PAGE_INDICES.PAYMENT].URL,
};

export const products = ['Family', 'Senior', 'Junior', 'County', 'Executive', 'Getrude']
